// src/utils/wordExport.ts - REPLACE YOUR FRONTEND FILE WITH THIS
import axiosInstance from "./axiosConfig";

interface WordExportOptions {
    artist?: string;
    venue?: string;
    venueAddress?: string;
    contactInfo?: {
        name: string;
        email: string;
        phone: string;
    };
}

export const exportScheduleToWord = async (schedule: any[], options: WordExportOptions) => {
    try {
        console.log('🔄 Starting Word export with:', { schedule: schedule.length, options });
        
        const response = await axiosInstance.post('/api/word/generate-schedule', {
            schedule,
            options
        }, {
            responseType: 'blob' // THIS IS CRITICAL - tells axios to expect binary data
        });
        
        console.log('✅ Word export response received:', response);
        
        // Create blob and download
        const blob = new Blob([response.data], { 
            type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' 
        });
        
        // Create download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        
        // Generate filename
        const artistName = options.artist?.replace(/[^a-zA-Z0-9]/g, '_') || 'Schedule';
        const timestamp = new Date().toISOString().split('T')[0];
        link.download = `${artistName}_schedule_${timestamp}.docx`;
        
        // Trigger download
        document.body.appendChild(link);
        link.click();
        
        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        console.log('✅ Word document downloaded successfully');
        return true;
        
    } catch (error: any) {
        console.error('❌ Error generating Word document:', error);
        throw new Error(`Failed to generate Word document: ${error.message}`);
    }
};